/**
 * Brand utilities for getting configurable brand information
 */

export const getBrandName = (): string => {
  return import.meta.env.VITE_BRAND_NAME || 'IoT Manager';
};

export const getBrandShortName = (): string => {
  return import.meta.env.VITE_BRAND_SHORT_NAME || getBrandName();
};

export const getBrandDescription = (): string => {
  return import.meta.env.VITE_BRAND_DESCRIPTION || `${getBrandName()} - A comprehensive IoT device management platform`;
};